import React, { PropsWithChildren } from 'react';
import { SectionHeadlineWrapper } from './SectionHeadlineStyles';

export const SectionHeadline: React.FC<PropsWithChildren> = (props) => {
  const { children } = props;
  return <SectionHeadlineWrapper>{children}</SectionHeadlineWrapper>;
};
